class SkillsModel {
  id;
  deleted;
  name;
  description;
  canTransfer;
  dateUpdated;
  skillOrder;
  skillRoutingConfiguration;
  skillTransferList;

  constructor(options) {
    this.id = options.id;
    this.deleted = options.deleted;
    this.dateUpdated = options.dateUpdated;
    this.skillOrder = options.skillOrder;
    this.name = options.name;
    this.description = options.description;
    this.canTransfer = options.canTransfer;
    this.skillRoutingConfiguration = options.skillRoutingConfiguration;
    this.skillTransferList = options.skillTransferList;
  }
}

export default SkillsModel;
